import { setupI18n } from "~/utils/i18n";
  
export const i18nInstance = setupI18n({
  legacy: false,
  fallbackLocale: false,
  allowDynamic: true,
  runtimeOnly: false,
  isGlobal: true,
  missingWarn: false,
  fallbackWarn: false,
});

export default defineNuxtPlugin( async ({ vueApp }) => {
  vueApp.use(i18nInstance);
});
